import Modal from "@/common/components/Modal"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm, SubmitHandler } from "react-hook-form"
import TextArea from "@/common/components/TextArea"
import { Dispatch, SetStateAction, useState } from "react"
import { blockPosSchema, BlockPosValidationSchema } from "../../schemas/blockPos.schema"
import { useBlockPos } from "@/features/pos/hooks/useBlockPos"
import { useParams } from "react-router-dom"

interface BlockPosModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onSuccess?: () => void
  onError?: () => void
}

const BlockPosModal = ({ isOpen, setIsOpen, onSuccess, onError }: BlockPosModalProps) => {
  const [serverError, setServerError] = useState(false)
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors }
  } = useForm<BlockPosValidationSchema>({
    resolver: zodResolver(blockPosSchema)
  })

  const {mutate, isPending} = useBlockPos({
    id,
    onSuccess: () => {
      resetForm();
      setServerError(false);
      setIsOpen(false);
      onSuccess?.();
    },
    onError: () => {
      setServerError(true);
      onError?.();
    },
  });

  const onSubmit: SubmitHandler<BlockPosValidationSchema> = (data) => {
    mutate(data);
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      disabled={isPending}
      showClose
      title="Justificativa para bloqueio"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Preencha o motivo para bloquear o POS"
      footer="Confirmar justificativa e salvar alteração"
      body={(
        <form className="flex flex-col gap-4">
          {serverError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>}
          <TextArea
            label="Justificativa"
            placeholder="Escreva aqui sua justificativa"
            errorMessage={errors?.description?.message}
            {...register('description')}
          />
        </form>
      )}
    />
  )
}

export default BlockPosModal